import { render } from "./RequestSummary.vue?vue&type=template&id=497f1db2&scoped=true"
import script from "./RequestSummary.vue?vue&type=script&lang=js"
export * from "./RequestSummary.vue?vue&type=script&lang=js"

import "./RequestSummary.vue?vue&type=style&index=0&id=497f1db2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497f1db2"]])

export default __exports__